import { useState } from 'react';
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import TableTab1 from './TableTab1';

const Tab1 = ({
  Numeric_Values,
  AttributeName,
  FromRange,
  ToRange,
  Increment,
  setselected_default_item_attribulte_data,
    pageState,
	changeState
}) => {
  return (
    <div>
      <div className="px-4 py-4" style={{ background: 'white' }}>

        <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>

              <div style={{ display: 'flex', gap: '15px', marginBottom: '-10px' }}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600', marginLeft: '2px' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                   <Input
              id="AttributeName"
              label="Attribute Name"
              style={{ height: "30px", border: AttributeName?.Error ? '1px solid red' : '' }}
              value={AttributeName?.value || ''}
              onChange={(e) => AttributeName?.setValue?.(e.target.value)}
            />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{height: '19px'}}></label>
                  <Checkbox
              id="Numeric_Values"
              label="Numeric Values"
              value={Numeric_Values?.value || false}
              onChange={(val) => Numeric_Values?.setValue?.(val)}
            />

                </div>
                
                <div style={{ flex: 1 }}>
                  
                </div>
                <div style={{ flex: 1 }}>
                  
                </div>
              </div>







            </div>
          </div>

        </div>
{Numeric_Values?.value ? (
        <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>

             
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <Input
                id="FromRange"
                label="From Range"
                style={{ height: "30px", border: FromRange?.Error ? '1px solid red' : '' }}
                value={FromRange?.value || ''}
                onChange={(e) => FromRange?.setValue?.(e.target.value)}
              />
                </div>
                 <div style={{ flex: 1 }}>
                   <Input
                id="ToRange"
                label="To Range"
                style={{ height: "30px", border: ToRange?.Error ? '1px solid red' : '' }}
                value={ToRange?.value || ''}
                onChange={(e) => ToRange?.setValue?.(e.target.value)}
              />
                </div>
                 <div style={{ flex: 1 }}>
                 <Input
                id="Increment"
                label="Increment"
                style={{ height: "30px", border: Increment?.Error ? '1px solid red' : '' }}
                value={Increment?.value || ''}
                onChange={(e) => Increment?.setValue?.(e.target.value)}
              />
                </div>
                
              </div>







            </div>
          </div>

        </div>
) : (
       
    <div className="mb-3" style={{ display: 'flex', gap: '20px',border: '1px solid #DBDBDB', borderRadius: '5px' }} >

            <div className="col-md-12">
              <div className='' style={{height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
 <div style={{ display: 'flex', gap: '15px'}}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Item Attribute Values</p>
                </div>
              </div>

                <TableTab1
 selected_default_item_attribulte_data={{
    value: pageState.selected_default_item_attribulte_data,
    setValue: (val) =>
      changeState({ ...pageState, selected_default_item_attribulte_data: val }),
  }}
/>




              </div>
            </div>

          </div>
        )}
      </div>
    </div>
  );
};

export default Tab1;
